import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class CatalogosService {

  url: string;
  opendata: string;

  constructor (
    private http: HttpClient
  ) {
    this.url = environment.api.base_endpoint;
    this.opendata = environment.api.opendata_endpoint;
  }

  async getCatalogo() {
    try {
      const res = await this.http.get(`${this.url}catalogos`).toPromise();
      return res;
    } catch (err) {}
  }

  async getHospitalizados () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/covid/hospitalizados`).toPromise();
      return res;
    } catch (err) {}
  }

  async getTramitesPublicados () {
    try {
      // const res = await this.http.get(`${this.opendata}tramites`).toPromise();
    } catch (err) {
      console.log('err ', err);
    }
  }

  async getCasosAsociados () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/covid/casos-asociados`).toPromise();

      return res;
    } catch (err) {

    }
  }


  async getCasosColonia () {
    try {
      const res = await this.http.get(`${this.url}opendata/covid/casos-colonia`).toPromise();

      return res;
    } catch (err) {

    }
  }

  async getCasosAlcaldias () {
    try {
      const res = await this.http.get(`${this.url}opendata/covid/casos-alcaldias`).toPromise();

      return res;
    } catch (err) {

    }
  }

  async getDependencia(id) {
    try {
      const res = await this.http.get(`https://sftys.cdmx.gob.mx/api/v2/dependencies/${id}`).toPromise();

      return res;
    } catch (err) {
      console.log("err");
    }
  }

  async getConfirmados() {
    try {
      const res = await this.http.get(`https://datos.cdmx.gob.mx/api/records/1.0/analyze/?refine.entidad_res=CIUDAD+DE+M%C3%89XICO&maxpoints=0&x=confirmados&y.count.expr=confirmados&y.count.func=COUNT&y.count.cumulative=false&dataset=casos-asociados-a-covid-19&timezone=America%2FMexico_City&lang=es`).toPromise();

      return res;
    } catch (error) {

    }
  }

  async getNegativos() {
    try {
      const res = await this.http.get(`https://datos.cdmx.gob.mx/api/records/1.0/analyze/?refine.entidad_res=CIUDAD+DE+M%C3%89XICO&maxpoints=0&x=negativos&y.count.expr=negativos&y.count.func=COUNT&y.count.cumulative=false&dataset=casos-asociados-a-covid-19&timezone=America%2FMexico_City&lang=es`).toPromise();

      return res;
    } catch (error) {

    }
  }

  async getSospechosos() {
    try {
      const res = await this.http.get(`https://datos.cdmx.gob.mx/api/records/1.0/analyze/?refine.entidad_res=CIUDAD+DE+M%C3%89XICO&maxpoints=0&x=sospechosos&y.count.expr=sospechosos&y.count.func=COUNT&y.count.cumulative=false&dataset=casos-asociados-a-covid-19&timezone=America%2FMexico_City&lang=es`).toPromise();

      return res;
    } catch (error) {

    }
  }

  async getSelect() {
    try {
      const res = await this.http.get(`https://datos.cdmx.gob.mx/api/records/1.0/search/?refine.entidad_res=CIUDAD+DE+M%C3%89XICO&rows=0&facet=municipio_res&facetsort.municipio_res=alphanum&dataset=casos-asociados-a-covid-19&timezone=America%2FMexico_City&lang=es`).toPromise();
      console.log("res ====> ", res)
      return res;
    } catch (error) {

    }
  }

  async getPlanApertura() {
    try {
      const res = await this.http.get(`${this.url}opendata/plan-apertura`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getMovilidad() {
    try {
      const res = await this.http.get(`${this.url}opendata/movilidad`).toPromise();
      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }


  async getAfluenciaPublico() {
    try {
      const res = await this.http.get(`${this.url}opendata/movilidad/afluencia/publico`).toPromise();
      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getCompartido() {
    try {
      const res = await this.http.get(`${this.url}opendata/movilidad/compartido`).toPromise();
      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getCompartidoSuburbano() {
    try {
      const res = await this.http.get(`${this.url}opendata/movilidad/compartido/suburbano`).toPromise();
      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getTransitoVehicular () {
    try {
      const res = await this.http.get(`${this.url}opendata/movilidad/vehicular`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getTransitoVehicularPrct () {
    try {
      const res = await this.http.get(`${this.url}opendata/movilidad/vehicularprct`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getAfluenciaMetro () {
    try {
      const res = await this.http.get(`${this.url}opendata/movilidad/afluencia/metro`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getAfluenciaMetroPromedio () {
    try {
      const res = await this.http.get(`${this.url}opendata/metro/promedio-en-el-metro-de-la-cdmx-por-semana-y-hora`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getAfluenciaMetrobus () {
    try {
      const res = await this.http.get(`${this.url}opendata/movilidad/afluencia/metrobus`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getAfluenciaMetrobusSemana () {
    try {
      const res = await this.http.get(`${this.url}opendata/movilidad/afluencia/metrobus/semana`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getAfluenciaTransito () {
    try {
      const res = await this.http.get(`${this.url}opendata/movilidad/afluencia/transito`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getAfluenciaTransitoWaze () {
    try {
      const res = await this.http.get(`${this.url}opendata/movilidad/afluencia/transito/waze`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getAfluenciaTransitoDiff () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/movilidad/afluencia/transito/diferencia`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getAfluenciaTransitoCuotaFinde () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/movilidad/afluencia/transito/cuotafinde`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getAfluenciaTransitoCuota () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/movilidad/afluencia/transito/cuota`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getSemujeres () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/covid/semujeres`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getHumanResources () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/covid/recursos-humanos-de-las-alcaldias`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getIngresosParquimetros () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/parquimetros/ingresos-parquimetros`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getPoligonosComites () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/parquimetros/poligonos-comites`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getEquiposCobro () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/parquimetros/equipos-cobro`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getRetoVerde () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/reto-verde`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getInfraSocial () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/infra-social`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getCityBudget () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/presupuesto-alcaldias`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getFederalResources () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/recursos-federales`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

  async getSistemasAgua () {
    try {
      const res = await this.http.get(`${this.opendata}opendata/sistemas-captacion-aguas`).toPromise();

      return res;
    } catch (err) {
      console.log("err => ", err);
    }
  }

}
